import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Navigation from './components/Navigation';
import LoadingSpinner from './components/LoadingSpinner';
import Footer from './components/Footer';
import Login from './pages/Login';
import CalendarView from './pages/Calendar';
import GroundSchool from './pages/GroundSchool';
import Training from './pages/Training';
import People from './pages/People';
import Aircraft from './pages/Aircraft';
import About from './pages/About';
import Contact from './pages/Contact';
import UserManual from './pages/UserManual';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Manage from './pages/Manage';
import MobileCalendar from './components/MobileCalendar';
import MobileAircraft from './components/MobileAircraft';
import MobilePeople from './components/MobilePeople';
import MobileNavigation from './components/MobileNavigation';
import PopupQuestionManager from './components/PopupQuestionManager';
import SchedulingAssistant from './components/SchedulingAssistant';
import { useIsMobile } from './utils/mobile';

const AppContent = () => {
  const { isLoading } = useApp();
  const isMobile = useIsMobile();
  
  React.useEffect(() => {
    const lastReload = localStorage.getItem('lastReload');
    const now = Date.now();
    const twelveHoursMs = 12 * 60 * 60 * 1000;
    
    if (!lastReload || now - parseInt(lastReload) > twelveHoursMs) {
      localStorage.setItem('lastReload', now.toString());
      if (lastReload) {
        window.location.reload();
      }
    }
  }, []);
  
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <Router>
        <PopupQuestionManager />
        <SchedulingAssistant />
        <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', maxWidth: '100vw', overflowX: 'hidden', paddingBottom: isMobile ? '88px' : '64px', boxSizing: 'border-box' }}>
          <div style={{ flex: 1, width: '100%' }}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Login />} />
              <Route path="/calendar" element={isMobile ? <MobileCalendar /> : <><Navigation /><CalendarView /></>} />
              <Route path="/events" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><GroundSchool /></div></> : <><Navigation /><GroundSchool /></>} />
              <Route path="/training" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><Training /></div></> : <><Navigation /><Training /></>} />
              <Route path="/people" element={isMobile ? <MobilePeople /> : <><Navigation /><People /></>} />
              <Route path="/aircraft" element={isMobile ? <MobileAircraft /> : <><Navigation /><Aircraft /></>} />
              <Route path="/manage/*" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><Manage /></div></> : <><Navigation /><Manage /></>} />
              <Route path="/about" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><About /></div></> : <About />} />
              <Route path="/contact" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><Contact /></div></> : <Contact />} />
              <Route path="/user-manual" element={isMobile ? <><MobileNavigation /><div className="mobile-page" style={{ paddingTop: '72px' }}><UserManual /></div></> : <UserManual />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </>
  );
};

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;